import Products from './Products';
import Product from './Product';
import {
  buyGiftCardPageQuery_products,
  OrderLineInput
} from '../../../../core-types';

type Props = {
  products: buyGiftCardPageQuery_products[];
  orderLines: OrderLineInput[];
  locked: boolean;
  onAddRemoveClick: (productId: string, quantity: number) => void;
};

const GiftCards = ({
  products,
  orderLines,
  locked,
  onAddRemoveClick
}: Props) => {
  const active = orderLines.length > 0;
  return (
    <Products>
      {products.map(product => {
        const orderLine = orderLines.find(p => p.productId === product.id);
        const quantity = orderLine ? orderLine.quantity : 0;
        return (
          <Product
            key={product.id}
            product={product}
            quantity={quantity}
            locked={locked}
            active={active}
            onAddClick={() => onAddRemoveClick(product.id, 1)}
            onRemoveClick={() => onAddRemoveClick(product.id, -1)}
          />
        );
      })}
    </Products>
  );
};

export default GiftCards;
